module.exports = __webpack_public_path__ + "static/img/top_pic.4b896de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/top_pic.png
// module id = EcwF
// module chunks = 1